<div [@controlErrorShake]="showErrors ? 'error' : 'no-error'">
  <ng-content />
</div>

@if (showErrors) {
  <div class="errors-container" @transitionMessages>
    <ng-content select="aw-form-field-error" />
  </div>
}
